import { hasFeature } from '@precert/has-feature';

import { useConfig } from './config';
const cache: Record<string, boolean> = {};

export function Feature({
  id,
  children,
}: {
  id: string;
  children: React.ReactNode;
}) {
  const { features = [] } = useConfig();
  // Features can be used with dynamic id (e.g. routes)
  if (!id) return children;
  if (cache[id] === undefined || cache[id] === null) {
    // TODO CCRA-37242
    cache[id] = hasFeature(id, features);
  }
  return cache[id] ? children : null;
}
